import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            className="bg-cloud-white border-misty-sage"
          >
            <div className="grid gap-1">
              {title && (
                <ToastTitle className="text-forest-green">{title}</ToastTitle>
              )}
              {description && (
                <ToastDescription className="text-forest-green/80">
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose className="text-forest-green hover:text-forest-green/80" />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
